import {
  CreateOrganizationAgencyLinkRequestBodyType,
  CreateOrganizationAgencyLinkResponseBodyType,
} from "@intelligems/ig-types";
import { adminKeys, organizationsKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const createOrganizationAgencyLink = async (
  data: ApiRequest<CreateOrganizationAgencyLinkRequestBodyType>
) => {
  const resp = await api.post<CreateOrganizationAgencyLinkResponseBodyType>(
    `/v2/admin/organization-agency-links`,
    {
      ...data.body,
    }
  );
  return resp.data;
};

export const useCreateOrganizationAgencyLink = () => {
  const queryClient = useQueryClient();
  return useMutation<
    CreateOrganizationAgencyLinkResponseBodyType,
    Error,
    ApiRequest<CreateOrganizationAgencyLinkRequestBodyType>,
    any
  >({
    mutationFn: async (data) => createOrganizationAgencyLink(data),
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: adminKeys.agency(
          variables.body.organizationAgencyLink.agencyId
        ),
      });
      void queryClient.invalidateQueries({
        queryKey: adminKeys.organizationAgencyLink(
          variables.body.organizationAgencyLink.agencyId
        ),
      });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.orgSummaries,
      });
    },
  });
};
